export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-arrow",
      toString: function () {
        return this.url;
      }
    }